$w.onReady(() => {
	$w("#post1").getPost().then(res => $w("#title").text = res.title)
})